export const environment = {
  production: true,
  appVersion: 'v18.41.1',
  USERDATA_KEY: 'authf649fc9a5f55',
  
  isMockEnabled: true,
  apiUrl: '',
  assetsPath: 'GDCoreView\\ClientApp\\src\\assets\\images\\',
  appThemeName: 'CapitalInvestments',
   securepw: 'z6!3T9ZDStsAbz#3f',
  decPassword: 'z6!3T9ZDStsAbz#3f',
  encPassword: 'z6!3T9ZDStsAbz#3f',
  version: 'v2025.12.0.2025',
  alertreptxt:
    'Please note the following missing requirement(s) prevent us from continuing the review/approval process:' +
    '\n' +
    ' * ' +
    '\n' +
    ' * ' +
    '\n' +
    ' * ' +
    '\n' +
    'The transaction cannot be processed and the alert will remain active until we receive notification that the missing item(s) have been uploaded into the system.' +
    '\n' +
    +'\n' +
    'Please verify the status of the submission is & quot; PROCESSING PAPERWORK & quot; when resubmitting for review / approval.',
  alertpendingtxt:
    'Please note the following missing item(s) are required:' +
    '\n' +
    ' * ' +
    '\n' +
    ' * ' +
    '\n' +
    ' * ' +
    '\n' +
    'This transaction will be coded with a pending alert as we continue the review / approval process.' +
    '\n' +
    +'\n' +
    ' A notification of an approval / or rejection of this transaction will be provided via email shortly.' +
    '\n' +
    +'\n' +
    ' This alert will remain active(even if the transaction is approved) until we have been notified that the missing item(s) have been uploaded into the system.',
  warningSurrender:
    ' Warning: Reminder - These are considered L-Shares and additional charges should' +
    '\n' +
    'be disclosed on Capitals VA Acknowledgement form, initialed by the client.',
  warningshares: 'Warning: This Share Class no longer applies!',
 };
